import { makeStyles } from '@material-ui/core/styles';
import { COLORS, STYLES } from 'utils';

export const useStyles = makeStyles({
	card: {
		...STYLES.card,
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'space-between',
		alignItems: 'center',
		border: '1px solid #F9F9F9',
		boxShadow: '0px 4px 3px rgba(0, 0, 0, 0.03)',
		borderRadius: 5,
		padding: 20
	},
	item: {
		width: '100%',
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	title: {
		fontSize: 16,
		fontWeight: 400,
		lineHeight: '16px'
	},
	value: {
		color: COLORS.primary,
		fontSize: 18,
		fontWeight: 800
	},
	itemInfoLabel: {
		color: COLORS.grey3,
		fontSize: 11,
		fontWeight: 600
	},
	itemInfoText: {
		color: COLORS.grey3,
		fontSize: 11,
		fontWeight: 600,
		marginLeft: 4
	},
	status: {
		color: COLORS.primary,
		width: '80px'
	},
	statusText: {
		marginBottom: 8,
		color: COLORS.grey3,
		fontSize: 12,
		fontWeight: 600
	},
	statusIndicator: {
		display: 'block',
		width: '12px',
		height: '12px',
		backgroundColor: '#E31010',
		borderRadius: '12px',
	},
	inactive: {
		backgroundColor: '#E31010',
	},
	active: {
		backgroundColor: '#28B772',
	},
});
